export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.198 13.2673C15.6005 13.6636 15.6005 14.3063 15.198 14.7027C14.7956 15.0991 14.1431 15.0991 13.7407 14.7027L9.22858 10.2583C8.82615 9.86189 8.17369 9.86189 7.77126 10.2583L3.25913 14.7027C2.85671 15.0991 2.20425 15.0991 1.80182 14.7027C1.39939 14.3063 1.39939 13.6636 1.80182 13.2673L7.77126 7.38739C8.17369 6.991 8.82615 6.991 9.22858 7.38739L15.198 13.2673Z"
        fill="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.80198 2.73274C1.39955 2.33635 1.39955 1.69368 1.80198 1.29729C2.2044 0.900903 2.85686 0.900903 3.25929 1.29729L7.77142 5.74172C8.17385 6.13811 8.82631 6.13811 9.22874 5.74172L13.7409 1.29729C14.1433 0.900903 14.7958 0.900903 15.1982 1.29729C15.6006 1.69368 15.6006 2.33635 15.1982 2.73274L9.22874 8.61261C8.82631 9.009 8.17385 9.009 7.77142 8.61261L1.80198 2.73274Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};
